export default {
  data(){
    return {
      homeTutorial      : {
        options   : {
          useKeyboardNavigation: false,
          labels: {
            buttonSkip: 'スキップ',
            buttonPrevious: '前へ',
            buttonNext: '次へ',
            buttonStop: '次へ' // [終了する|次へ]
          }
        },

        callbacks : {
          onSkip : () => {
            this.$store.dispatch({
              type  : 'tutorial/updateSingleShouldOpenTour',
              name  : 'home',
              value : false
            });
          },

          onFinish : () => {
            this.$store.dispatch({
              type  : 'tutorial/updateSingleShouldOpenTour',
              name  : 'home',
              value : false
            });
            
            if(this.tourType === 'through'){
              this.$store.dispatch({
                type  : 'tutorial/updateShouldOpenTour',
                name  : 'office'
              });
            }
          }
        },

        steps : [
        ],

        stepsTemplate : [
          {
            target: '.pa-reward-progress',
            content: `こちらのバーは各種経験値を表示しております。黄色の場合は貴方様自身のチャプター経験値、紫色の場合はひろばの地区経験値を表示しております。`
          },
          {
            target: '.pa-global-header > .main-field',
            content: `塔経市帝の新聞社、塔経瞬時が提供する最新情報が表示されております。`
          },

          {
            target: '.flash-line-box > .title-field > svg',
            content: `こちらのボタンより貴方様宛に届きました最新情報をご確認いただくことができます。`
          },

          {
            target: '.icon-slot-home',
            content: 'それではマイページについてご案内を進めて参ります。',
            params : {
              placement: 'top',
            }
          },

          {
            target: '.pa-section-character-status-index',
            content: '異界滞在索引では貴方様の異界滞在の各種情報が表示されております。',
            offset: -200,
            params : {
              placement: 'top',
            }
          },

          {
            target: '.pa-section-login-stamp-card',
            content: '貴方様の異界滞在履歴が御確認頂けます。',
            offset: -200,
            params : {
              placement: 'top',
            }
          },

          {
            target: '.pa-section-story-list-widget-new',
            content: '電子的異界渡航生活の御伴に最適な物語を御楽しみ頂けます。',
            offset: -200,
            params : {
              placement: 'top',
            }
          },

          {
            target: '.icon-slot-office',
            content: 'それでは事務所について解説させていただきます。',
            params : {
              placement: 'top',
            }
          }
        ],
      }
    }
  },

  watch : {
    tourType : {
      handler(value){
        let newSteps = [];
        let stopButtonLabel = '終了する';

        switch(value){
          case 'single':
            newSteps = this.homeTutorial.stepsTemplate.slice(0, 7);

            stopButtonLabel = '終了する';
          break;

          case 'through':
            newSteps = this.homeTutorial.stepsTemplate.slice(0, 8);

            stopButtonLabel = '次へ';
          break;
        }

        this.homeTutorial.steps = newSteps;
        this.homeTutorial.options.labels.buttonStop = stopButtonLabel;
      },
      immediate: true,
      deep: true
    }
  }
}